import { Component, computed, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogResultData, AbstractFormDialogData, AgrDialogModule } from '@next/core-lib/dialog';

import { LocaleService } from '@next/core-lib/i18n';

import { ValidationError } from '../../../shared/models';
import { SharedModule } from '../../../shared/shared.module';

export interface ValidationErrorsDialogData extends AbstractFormDialogData {
  validationErrors: ValidationError[];
}

@Component({
  selector: 'app-validation-errors-dialog',
  standalone: true,
  imports: [SharedModule, AgrDialogModule],
  template: `
    <agr-dialog [data]="data" (close)="cancel()" (cancel)="cancel()">
      @for (message of messages(); track message) {
        <li>{{ message }}</li>
      } @empty {
        <p>{{ 'errors.UN001' | translate }}</p>
      }
    </agr-dialog>
  `,
})
export class ValidationErrorsDialogComponent extends AbstractDialog<ValidationErrorsDialogData> {
  readonly data = inject<ValidationErrorsDialogData>(MAT_DIALOG_DATA);
  protected readonly mdDialogRef = inject<MatDialogRef<ValidationErrorsDialogComponent, AbstractDialogResultData>>(MatDialogRef);
  private readonly localeService = inject(LocaleService);

  protected messages = computed<string[]>(() => {
    const errors = this.data?.validationErrors;
    if (!Array.isArray(errors)) {
      return [];
    }

    return errors.map((error) => {
      if (error.code?.trim()) {
        return this.localeService.translate(`errors.${error.code}`, error.data);
      }

      if (error.message?.trim()) {
        const skuTitle = error.data?.SkuTitle?.trim();
        return skuTitle ? `${error.message} (${skuTitle})` : error.message;
      }

      return this.localeService.translate('errors.UN001');
    });
  });
}
